module.exports = __webpack_public_path__ + "montserrat-bold-webfont.9e3db.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/montserrat-bold-webfont.woff
// module id = ./src/_asset/sources/assets/fonts/woff/montserrat-bold-webfont.woff
// module chunks = main